var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    [
      _c(
        "v-btn",
        {
          attrs: { icon: "" },
          on: {
            click: function ($event) {
              return _vm.toggleView()
            },
          },
        },
        [_c("v-icon", [_vm._v(_vm._s(_vm.toggleViewIcon))])],
        1
      ),
      _c(
        "v-btn",
        {
          attrs: { icon: "" },
          on: {
            click: function ($event) {
              return _vm.mostraOpzioni()
            },
          },
        },
        [
          _c(
            "v-icon",
            { attrs: { color: _vm.filtriApplicati ? "green" : undefined } },
            [_vm._v("mdi-file-find")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }